import "@/instrument"; // Sentry init — must come before any other import.
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SharedTemplate from "@/pages/SharedTemplate";

// Tiny path-based router. Public static pages (privacy/terms) and the share
// landing (/t/<id>) need to render without the onboarding/profile gate so
// app-store reviewers, search engines, and link recipients can reach them.
function pickRoot() {
  if (typeof window === "undefined") return <App />;
  const p = window.location.pathname;
  if (p === "/privacy" || p === "/privacy/") return <Privacy />;
  if (p === "/terms" || p === "/terms/") return <Terms />;
  const tMatch = p.match(/^\/t\/([A-Za-z0-9_-]{4,})\/?$/);
  if (tMatch) return <SharedTemplate templateId={tMatch[1]} />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:24,color:'#fff',background:'#0F0F0F',minHeight:'100vh'}}>Something went wrong. Our team has been notified.</div>}>
      {pickRoot()}
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
